import React from 'react';
import './styles.css';
import { Row, Col } from 'antd';

const DividerContainer = ({ title }) => {
  return (
    <Row className="divider-container">
      <Col span={24}>
        <h2 className="divider-container_title">{title}</h2>
      </Col>
    </Row>
  );
};

export default DividerContainer;
